import type { ThemeTokens } from "@yamada-ui/core"

export const letterSpacings: ThemeTokens = {
  tighter: "-0.05em",
  tight: "-0.025em",
  normal: "0",
  wide: "0.025em",
  wider: "0.05em",
  widest: "0.1em",
}
